<template>
  <div class="logout-container">
    <div class="login_form_box">
      <p class="logout-title">Account Cancellation</p>
      <el-form :model="formLogin" :rules="loginRules" ref="loginFormRef">
        
        <el-form-item prop="username">
          <el-input
            class="h-[40px]"
            placeholder="Enter email address"
            v-model="formLogin.username"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            class="h-[40px]"
            v-model="formLogin.password"
            placeholder="Enter login password"
            type="password"
            show-password
          />
        </el-form-item>
        <div
          class="btn"
          @click="logout"
          >Log Off</div
        >
      </el-form>
      <div class="info-box">
        <img src="./assets//images//warn.png" alt="" width="30px" height="30px">
        <p class="info">After logging off, all data uploaded will be cleared, and the connection with the photo frame will be terminated. Please proceed with caution.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from "vue";
import axios from "axios";
import { ElMessage } from "element-plus";
import { loginApi, logoutApi } from "@/http/logout";
const formLogin = reactive({
  username: "",
  password: "",
});
let isLoading = ref(false)
const loginFormRef = ref(null);
const loginRules = reactive({
  username: [{ required: true, message: "email required", trigger: "blur" }],
  password: [{ required: true, message: "password required", trigger: "blur" }],
});
const logout = async () => {
  if (!formLogin.username) {
    ElMessage({
      message: `please enter email address`,
      type: "warning",
    });
    return 
  }
  if (!formLogin.password) {
    ElMessage({
      message: `please enter password`,
      type: "warning",
    });
    return 
  }
  setTimeout(() => {
    ElMessage({
      message: "Successfully logged off",
      type: "success",
    });
    formLogin.username = ''
    formLogin.password = ''
  }, 800)
  let data = {
    account: formLogin.username,
    password: formLogin.password,
    tenantId: "1",
    platform: 0,
  };
  let loginRes = await loginApi(data);
  // console.log("loginRes---", loginRes);
  if (loginRes.code == 0) {
    logoutApi(loginRes.data.token).then((outRes) => {
      isLoading.value = true
      console.log("outres---", outRes);
      if (outRes.code == 0) {
        // ElMessage({
        //   message: "Successfully logged off",
        //   type: "success",
        // });
        formLogin.username = ''
        formLogin.password = ''
      }
    }).catch(err => {
      isLoading.value = false
    }).finally(() => {
      isLoading.value = false
    });
  } else if (loginRes.code == 408) {
    // ElMessage({
    //   message: `user dose not exist`,
    //   type: "warning",
    // });
  } else if (loginRes.code == 149) {
    // ElMessage.error('Incorrect account password')
  }
  // axios({
  //   url: '/v1/uim/common/app/login',
  //   data,
  //   method: 'post'
  // }).then(res => {
  //   console.log('res---', res)
  // })
};
onMounted(() => {
		// console.log('当前环境：--',process.env.VUE_APP_API_URL)
})
</script>

<style scoped>
.logout-container {
  width: 100%;
  height: 100%;
  background: pink;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("./assets/images/bg.jpg") !important;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}
.login_form_box {
  width: 500px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-color: rgba(255, 255, 255, 0.7); */
  background-color: #ffffff;
  border-radius: 20px;
}
.btn {
  width: 100%;
  height: 35px;
  background: #FDB117;
  cursor: pointer;
  line-height: 35px;
  text-align: center;
  color: #fff;
  font-size: 15px;
  border-radius: 5px
}
.logout-title {
  position: relative;
  bottom: 20px;
  font-size: 20px;
}
.info-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* height: 50px; */
  /* background: pink */
}
.info {
  font-size: 12px;
  width: 400px;
  color: #D8D8D8;
  margin-top: 10px
}
</style>
<style>
.login_form_box {
}
.el-input {
  width: 350px !important;
  color: #000 !important;
}
.el-input__wrapper {
  height: 30px;
  background-color: rgba(255, 255, 255, 1) !important;
  box-shadow: none;
  padding-left: 6px;
  padding-right: 30px;
}
.el-input__inner {
  width: 100%;
  color: #626161 !important;
}
</style>
